/**
 * Sort helper: -1/1 puts a null/undefined value after a present one in either direction, 0 for two
 * missing, and null when both are present (the caller compares them).
 */
export function compareMissingLast(a: unknown, b: unknown): number | null {
  const aMissing = a === null || a === undefined;
  const bMissing = b === null || b === undefined;
  if (aMissing && bMissing) return 0;
  if (aMissing) return 1;
  if (bMissing) return -1;
  return null;
}
